import React from 'react';
import styled from 'styled-components';
import { Icon, IconTypes } from 'components/Icon';
import { theme, toRem } from 'design';
import { IntegrationType } from 'types';

interface IIntegrationLogoProps {
  type?: IntegrationType;
}

const Wrapper = styled.div`
  margin: ${toRem(theme.space.sm)};
`;

const integrationIconMap: Partial<Record<IntegrationType, { icon: IconTypes; width?: number; height?: number }>> = {
  [IntegrationType.ADORA]: { icon: 'Adora', width: 88 },
  [IntegrationType.ALOHA]: { icon: 'Aloha', width: 88 },
  [IntegrationType.BRINK]: { icon: 'Brink', width: 88 },
  [IntegrationType.CINEMARK]: { icon: 'Cinemark', width: 40, height: 40 },
  [IntegrationType.HEARTLAND]: { icon: 'Genius', width: 68, height: 32 },
  [IntegrationType.ORACLE]: { icon: 'Oracle', width: 88 },
  [IntegrationType.RPOWER]: { icon: 'RPower', width: 88 },
  [IntegrationType.SHIFT4]: { icon: 'Shift4', width: 88 },
  [IntegrationType.SQUARE]: { icon: 'SquareLogo', width: 88 },
  [IntegrationType.TOAST]: { icon: 'Toast', width: 120 },
  [IntegrationType.UNION]: { icon: 'UnionPOS', width: 120 },
  [IntegrationType.KICKFIN]: { icon: 'LogoMark', width: 120 },
};

const IntegrationLogo: React.FC<IIntegrationLogoProps> = ({ type }: IIntegrationLogoProps) => {
  if (!type) return null;
  const props = integrationIconMap[type.toLowerCase() as IntegrationType];
  if (!props) return null;

  return (
    <Wrapper>
      <Icon {...props} />
    </Wrapper>
  );
};

export default IntegrationLogo;
